export default function fixColsContainer() {
    const containers = document.querySelectorAll(".cols-container");
    if (containers.length == 0) {
        return;
    }

    for (let container of containers) {
        fix(container);
    }
}

const cmsClasses = [
    "cms-action-inline-panel",
];

function fix(container) {
    const leftColumn = container.querySelector(".page-left-col");
    if (!leftColumn) {
        return;
    }

    if (leftColumn.children.length == 0) {
        emptyContainer(container);
        return;
    }

    const subsections = container.querySelector(".subsection-content");
    if (!subsections) {
        return;
    }

    if (subsections.children.length == 0) {
        emptyContainer(container);
        return;
    }

    if (subsections.children.length > 1) {
        return;
    }

    for (let child of subsections.children) {
        for (let className of child.classList) {
            if (cmsClasses.includes(className)) {
                emptyContainer(container);
                return;
            }
        }
    }
}

function emptyContainer(container) {
    container.classList.add("left-empty");
}
